import React, { useMemo } from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { Link } from '@contrast-security-inc/design-system-typography'
import { Description } from '../../../legacy-design-system/legacy-grid'

export const IpListBridgeComponent = ({ listType }: { listType: ListType }) => {
  const isNorthstarUI = useMemo(() => {
    return window.isEmbeddedInNS === true
  }, [])
  const adrSuffix = useMemo(() => {
    return isNorthstarUI ? '_adr' : ''
  }, [isNorthstarUI])
  return (
    <Description
      content={{
        id:
          listType === 'DENY'
            ? `detail_ipsManagement_denylistDefinition${adrSuffix}`
            : `detail_ipsManagement_allowlistDefinition${adrSuffix}`,
        values: {
          link: (...msg) => (
            <Link
              isExternal
              href="https://docs.contrastsecurity.com/en/block-or-allow-ips.html"
            >
              {msg}
            </Link>
          )
        }
      }}
    />
  )
}

type ListType = 'ALLOW' | 'DENY'

export const reactLegacyGridIpListDescription = createNgReactBridgeDirective(
  'reactLegacyGridIpListDescription',
  [],
  IpListBridgeComponent,
  ['listType']
)
